<template>
	<q-card style="width: 80vw; min-width: 80vw; height: 80vh">
		<q-toolbar>
			<q-toolbar-title>{{ $t('certificate') }}</q-toolbar-title>

			<q-btn flat round dense icon="fal fa-times" v-close-popup />
		</q-toolbar>

		<q-separator />

		<q-card-section>
			<div class="row text-center">
				<div class="col-12">
					<template v-for="network in networks" :key="network.network">
						<ShareNetwork
							v-if="certificate.image_shareable"
							:network="network.network"
							:url="certificate.image_shareable"
							:title="title"
							:description="description"
							:quote="description"
						>
							<q-btn
								flat
								round
								:icon="network.icon"
								color="black"
								v-if="network.network != 'twitter'"
							/>
							<q-btn flat round :icon="`img:${icon_x_twitter}`" v-else />
						</ShareNetwork>
					</template>

					<q-btn flat round color="black" icon="fal fa-print" @click="print()" />
				</div>

				<div class="col-12 print-centificate">
					<img :src="certificate.image" />
				</div>
			</div>
		</q-card-section>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import IconXTwitter from 'src/assets/icon/x-twitter.svg'

export default {
	name: 'Certificate',

	props: ['certificate', 'course'],

	data() {
		return {
			icon_x_twitter: null,
			networks: [
				{
					network: 'facebook',
					name: 'Facebook',
					icon: 'fab fah fa-lg fa-facebook-f',
					color: '#1877f2',
				},
				{
					network: 'linkedin',
					name: 'LinkedIn',
					icon: 'fab fah fa-lg fa-linkedin',
					color: '#007bb5',
				},
				{ network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
				{
					network: 'whatsapp',
					name: 'Whatsapp',
					icon: 'fab fah fa-lg fa-whatsapp',
					color: '#25d366',
				},
			],
		}
	},

	computed: {
		...mapGetters({
			full_name: 'common/full_name',
		}),

		site_url() {
			return process.env.SITE_URL
		},

		title() {
			return this.$t('new_certificate_in_course', { title: this.course.title })
		},

		description() {
			return this.$t('received_a_certificate_in_course', {
				name: this.full_name,
				title: this.course.title,
			})
		},
	},

	methods: {
		print() {
			let certificate = document.querySelector('.print-centificate').innerHTML
			let html = `
            <html>
                <head></head>
                    <style type="text/css" media="print">
                        @page {
                            size: landscape;
                        }
                        .printable.box {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 90vh;
                        }
                    </style>
                    <body>
                        <div class="printable">
                            <div class="printable box">
                                ${certificate}
                            </div>
                        </div>
                    </body>
            </html>
            `

			let myWindow = window.open('', '', '')
			myWindow.document.write(html)

			myWindow.document.close()
			myWindow.focus()

			setTimeout(() => {
				myWindow.print()
			}, 200)
		},
	},

	created() {
		this.icon_x_twitter = IconXTwitter
	},
}
</script>

<style></style>
